// Libraries.
import { scarpaGray300 } from '@habitech/shared';
import styled from 'styled-components';

export const Container = styled.div`
    margin: 48px 0;
    .MuiDataGrid-columnHeaderTitle {
        font-weight: bold;
    }
    .MuiDataGrid-row {
        max-height: unset !important;
    }
    .MuiDataGrid-cell {
        height: auto !important;
        line-height: unset;
        align-content: center;
    }
`;

export const LabelRow = styled.div`
    display: flex;
    gap: 4px;
    font-size: 11px;
    flex-wrap: wrap;
    line-height: 12px;
    padding: 4px 0;
    .item {
        display: inline-block;
        span {
            color: ${scarpaGray300};
            margin: 0 4px;
        }
    }
`;

export const ButtonWrapper = styled.div`
    padding: 8px 0;
    margin-left: -16px;
`;
